const API_URL =
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_API_URL
    : "http://localhost:5000";

// Resolve a stored attachment URL to a full, loadable URL. Absolute URLs are
// returned as-is; relative "/uploads/..." paths are prefixed with API_URL.
const imageUrl = (url) =>
  !url ? "" : url.startsWith("http") ? url : `${API_URL}${url}`;

export { API_URL, imageUrl };
